import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {
    setFixedAssetBookReportRequestData,
    setFixedAssetBookReportResponseData
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {getGreekCurrencyFormat, hookCompanyLogo, isEmpty} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import axios from "axios";
import {toast} from "react-toastify";
import ReportsTemplate from "../../../common/ReportsTemplate";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import DateBox from "../../../primer/DateBox";
import Pagination from "../../../primer/Pagination";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import * as XLSX from "xlsx";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {jsPDF} from "jspdf";
import {autoTable} from "jspdf-autotable";
import Input from "../../../common/Input";
import BetterCheckBox from "../../../common/BetterCheckBox";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import {openBuy} from "../../../../_helpers/tabOpeners";
import useTaggedDispatch from "../../../../hooks/useTaggedDispatch";

const ReportFixedAssetBook = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const installationOptions = useInstallationOptions(false);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const requestData = useSelector((state) => state.FIXED_ASSETS.fixedAssetBookReportRequestData[tabKey]);
    const responseData = useSelector((state) => state.FIXED_ASSETS.fixedAssetBookReportResponseData[tabKey]);
    const setRequestData = (data) => dispatch(setFixedAssetBookReportRequestData(data));
    const setResponseData = (data) => dispatch(setFixedAssetBookReportResponseData(data));

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);

    useEffect(() => {
        if (isEmpty(requestData.date_to)) {
            setRequestData({
                ...requestData,
                date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
            })
        }
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            setRequestData(reqData);
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/report-book`, {
            headers: { "Content-Type": "application/json" },
            params: {
                ...reqData,
                company: company.id,
                year: company.year,
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                if (!fromPagination) toast.success("Επιτυχής ανανέωση δεδομένων.", {autoClose: 1000});
                setResponseData({...responseData, data: res.data.data, totalPages: res.data.totalPages, totals: res.data.totals});
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        }
        setRequestData({...requestData, ...prepChange});
    }

    const dataCollectForExport = async () => {
        let totalData = [];
        try {
            const resp = await axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/report-book`, {
                headers: { "Content-Type": "application/json" },
                params: {
                    ...requestData,
                    page: -1,
                    company: company.id,
                    year: company.year,
                }
            });
            if (resp.data.status === "200") {
                totalData = resp.data.data;
            }
        } catch (err) {
            console.log(err);
        }
        return totalData;
    }

    const handlePageChange = (page) => {
        setRequestData({...requestData, page: page});
        setPageChanged(true);
    }

    const handleExcelExport = async () => {
        setLoadingPrint(true);
        const totalData = await dataCollectForExport();
        if (totalData.length > 0) {
            let rows = [];
            const dateExported = moment().format("DD/MM/YYYY HH:mm:ss");
            rows.push(["Επωνυμία:", company.name]);
            rows.push(["ΑΦΜ:", company.vatNumber]);
            rows.push(["Ημερομηνία Εξαγωγής:", dateExported]);
            rows.push([]);
            if (requestData.include_buys) {
                rows.push([
                    "Αρ.", "Κωδ. Συστήματος / Χειρ. Κωδικός", "Όνομα", "Ποσότητα", "Συσχετιζόμενοι Λογιστικοί Λογαριασμοί", "Ημ/νια Κτήσης", "Εγγραφή Αγοράς", "Αξία κτήσης", "Απογραφή", "Κίνηση", "Συνολική Αποσβεσμένη αξία", "Αναπόσβεστη αξία / Υπόλοιπο"
                ])
            } else {
                rows.push([
                    "Αρ.", "Κωδ. Συστήματος / Χειρ. Κωδικός", "Όνομα", "Ποσότητα", "Συσχετιζόμενοι Λογιστικοί Λογαριασμοί", "Ημ/νια Κτήσης", "Αξία κτήσης", "Απογραφή", "Κίνηση", "Συνολική Αποσβεσμένη αξία", "Αναπόσβεστη αξία / Υπόλοιπο"
                ])
            }
            let idx = 1;
            let totalAcquisition = 0;
            let totalCensus = 0;
            let totalUsage = 0;
            let accumulatedDepreciation = 0;
            let totalBalance = 0;
            for (const row of totalData) {
                if (requestData.include_buys) {
                    rows.push([
                        String(idx),
                        row["mixedCode"],
                        row["name"],
                        row["quantity"],
                        row["accountingAccounts"],
                        row["dateFrom"],
                        row["correlatedBuyLabel"] || "",
                        +row["acquisitionCost"],
                        +row["totalCensus"],
                        +row["totalUsage"],
                        +row["accumulatedDepreciation"],
                        row["isSold"] === true ? "ΕΠΩΛΗΘΗ" : +row["balance"],
                    ])
                } else {
                    rows.push([
                        String(idx),
                        row["mixedCode"],
                        row["name"],
                        row["quantity"],
                        row["accountingAccounts"],
                        row["dateFrom"],
                        +row["acquisitionCost"],
                        +row["totalCensus"],
                        +row["totalUsage"],
                        +row["accumulatedDepreciation"],
                        row["isSold"] === true ? "ΕΠΩΛΗΘΗ" : +row["balance"],
                    ])
                }
                idx++;
                totalAcquisition += +row["acquisitionCost"];
                totalCensus += +row["totalCensus"];
                totalUsage += +row["totalUsage"];
                accumulatedDepreciation += +row["accumulatedDepreciation"];
                totalBalance += row["balance"] === -1 ? 0 : +row["balance"];
            }
            if (requestData.include_buys) {
                rows.push([
                    "", "", "", "", "", "", "ΣΥΝΟΛΑ",
                    +totalAcquisition.toFixed(2), +totalCensus.toFixed(2),
                    +totalUsage.toFixed(2), +accumulatedDepreciation.toFixed(2),
                    +totalBalance.toFixed(2),
                ]);
            } else {
                rows.push([
                    "", "", "", "", "", "ΣΥΝΟΛΑ",
                    +totalAcquisition.toFixed(2), +totalCensus.toFixed(2),
                    +totalUsage.toFixed(2), +accumulatedDepreciation.toFixed(2),
                    +totalBalance.toFixed(2),
                ]);
            }
            const workSheet = XLSX.utils.aoa_to_sheet(rows);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, "Βιβλίο Παγίων");
            XLSX.writeFile(workBook, "Βιβλίο Παγίων.xlsx");
        }
        setLoadingPrint(false);
    }

    const handlePDFExport = async () => {
        setLoadingPrint(true);
        const totalData = await dataCollectForExport();
        if (totalData.length > 0) {
            let rows = [];
            let columns;
            if (requestData.include_buys) {
                columns = [
                    "Αρ.", "Κωδ. Συστήματος / Χειρ. Κωδικός", "Όνομα", "Ποσότητα", "Συσχετιζόμενοι Λογιστικοί Λογαριασμοί", "Ημ/νια Κτήσης", "Εγγραφή Αγοράς", "Αξία κτήσης", "Απογραφή", "Κίνηση", "Συνολική Αποσβεσμένη αξία", "Αναπόσβεστη αξία / Υπόλοιπο"
                ]
            } else {
                columns = [
                    "Αρ.", "Κωδ. Συστήματος / Χειρ. Κωδικός", "Όνομα", "Ποσότητα", "Συσχετιζόμενοι Λογιστικοί Λογαριασμοί", "Ημ/νια Κτήσης", "Αξία κτήσης", "Απογραφή", "Κίνηση", "Συνολική Αποσβεσμένη αξία", "Αναπόσβεστη αξία / Υπόλοιπο"
                ]
            }
            let idx = 1;
            for (const row of totalData) {
                if (requestData.include_buys) {
                    rows.push([
                        String(idx),
                        row["mixedCode"],
                        row["name"],
                        row["quantity"],
                        row["accountingAccounts"],
                        row["dateFrom"],
                        row["correlatedBuyLabel"] || "",
                        getGreekCurrencyFormat(row["acquisitionCost"]),
                        getGreekCurrencyFormat(row["totalCensus"]),
                        getGreekCurrencyFormat(row["totalUsage"]),
                        getGreekCurrencyFormat(row["accumulatedDepreciation"]),
                        row["isSold"] === true ? "ΕΠΩΛΗΘΗ" : getGreekCurrencyFormat(row["balance"]),
                    ])
                } else {
                    rows.push([
                        String(idx),
                        row["mixedCode"],
                        row["name"],
                        row["quantity"],
                        row["accountingAccounts"],
                        row["dateFrom"],
                        getGreekCurrencyFormat(row["acquisitionCost"]),
                        getGreekCurrencyFormat(row["totalCensus"]),
                        getGreekCurrencyFormat(row["totalUsage"]),
                        getGreekCurrencyFormat(row["accumulatedDepreciation"]),
                        row["isSold"] === true ? "ΕΠΩΛΗΘΗ" : getGreekCurrencyFormat(row["balance"]),
                    ])
                }
                idx++;
            }
            const totalAcquisitionCost = +Number(totalData.reduce((sum, item) => sum + (item.acquisitionCost || 0), 0)).toFixed(2);
            const totalCensus = +Number(totalData.reduce((sum, item) => sum + (item.totalCensus || 0), 0)).toFixed(2);
            const totalUsage = +Number(totalData.reduce((sum, item) => sum + (item.totalUsage || 0), 0)).toFixed(2);
            const totalAccumulatedDepreciation = +Number(totalData.reduce((sum, item) => sum + (item.accumulatedDepreciation || 0), 0)).toFixed(2);
            const totalBalance = +Number(totalData.reduce((sum, item) => sum + (item.balance || 0), 0)).toFixed(2);
            rows.push([
                {content: "Σύνολα", colSpan: requestData.include_buys ? 7 : 6, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalAcquisitionCost), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalCensus), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalUsage), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalAccumulatedDepreciation), colSpan: 1, styles: {fillColor: "#decae3"}},
                {content: getGreekCurrencyFormat(totalBalance), colSpan: 1, styles: {fillColor: "#decae3"}},
            ])
            const doc = new jsPDF('landscape');
            let y = 20;

            doc.addFileToVFS("arialuni.ttf", liberationSerif);
            doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
            doc.addFileToVFS("dejavusans.ttf", dejavuSans);
            doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
            doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
            doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

            hookCompanyLogo(doc, companyDetails);

            const imgData = 'assets/images/prrimer-logo.png';
            const primerWidth = 28;
            const primerHeight = 10;
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            doc.addImage(imgData, 'PNG', pageWidth - primerWidth - 10, pageHeight - primerHeight - 5, primerWidth, primerHeight);
            doc.setFont("DejaVu Sans Bold");
            doc.setFontSize(12);
            let dateTo = requestData.date_to;
            if (isEmpty(dateTo)) dateTo = moment(company.year, "YYYY", true).endOf("year").format("DD/MM/YYYY");
            const header = doc.splitTextToSize(`Βιβλίο παγίων έως ${dateTo}`, 200);
            const headerString = header.join("\n");
            doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});

            doc.setFont("DejaVu Sans Normal");

            autoTable(doc, {
                startY: y,
                head: [columns],
                body: rows,
                rowPageBreak: "avoid",
                styles: {
                    font: "DejaVu Sans Normal",
                    fontStyle: "normal",
                    fontSize: 8, // set font size
                    halign: "center", // set alignment
                },
            })
            const pageCount = doc.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(10);
                doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
            }
            doc.save("Βιβλίο Παγίων.pdf");
        }
        setLoadingPrint(false);
    }

    const thickBorderStyle = "2px solid #76aeb7";

    return (
        <div>
            <ReportsTemplate
                templateType={"report-fixed-asset-book"}
                requestData={requestData}
                fetchReport={() => fetchReport()}
                setRequestData={(data) => setRequestData(data)} header={"Βιβλίο Παγίων"}
            />

            <Row onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false);
            }}>
                <Col md={2}>
                    <DateBox
                        name={"date_to"}
                        selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                        label={"Ημερομηνία έως"}
                        onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        label={"Όνομα/Κωδικός παγίου"}
                        name={"generalFilter"}
                        value={requestData.generalFilter}
                        onChange={(e) => handleOnChange(e, "input", "generalFilter")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        label={"Αξία κτήσης από"}
                        type={"number"}
                        name={"acquisitionCost_from"}
                        value={requestData.acquisitionCost_from}
                        onChange={(e) => handleOnChange(e, "input", "acquisitionCost_from")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        label={"Αξία κτήσης έως"}
                        type={"number"}
                        name={"acquisitionCost_to"}
                        value={requestData.acquisitionCost_to}
                        onChange={(e) => handleOnChange(e, "input", "acquisitionCost_to")}
                    />
                </Col>
                <Col md={3}>
                    <div style={{marginTop: "33px"}}>
                        <BetterCheckBox
                            name={"include_zero_balance"}
                            text={"Συμπερίληψη αποσβεσμένων παγίων"}
                            checked={requestData.include_zero_balance}
                            onChange={(e) => handleOnChange(e, "cb", "include_zero_balance")}
                        />
                    </div>
                </Col>
            </Row>
            <Row className={"d-flex justify-content-end"}>
                <Col md={3} className={"d-flex justify-content-end"}>
                    <Button style={{marginTop: "23px"}} onClick={() => fetchReport(false)} disabled={loading}>
                        Εφαρμογή Φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Col>
            </Row>
            {responseData.data.length > 0 && (
                <React.Fragment>
                    <hr/>
                    <Row>
                        <Col md={3}>
                            <BetterCheckBox
                                name={"include_buys"}
                                text={"Διατύπωση εγγραφών αγορών σε νέα στήλη"}
                                checked={requestData.include_buys}
                                onChange={(e) => handleOnChange(e, "cb", "include_buys")}
                            />
                        </Col>
                        <Col md={3}>

                        </Col>
                        <Col md={6} className={"d-flex justify-content-end"}>
                            <Pagination
                                currentPage={requestData.page}
                                totalPages={responseData.totalPages}
                                handlePageChange={(page) => handlePageChange(page)}
                            />
                        </Col>
                    </Row>
                    <Row className={"mt-2"}>
                        <Col md={12}>
                            <table className={"simpleClassicTable simpleClassicTableGrayHover"} style={{fontSize: "12px"}}>
                                <colgroup>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    {requestData.include_buys && (
                                        <col span={1} style={{width: "10%"}}></col>
                                    )}
                                    <col span={1} style={{width: "5%", borderTop: thickBorderStyle, borderBottom: thickBorderStyle, borderLeft: thickBorderStyle}}></col>
                                    <col span={1} style={{width: "5%", borderTop: thickBorderStyle, borderBottom: thickBorderStyle}}></col>
                                    <col span={1} style={{width: "5%", borderTop: thickBorderStyle, borderBottom: thickBorderStyle}}></col>
                                    <col span={1} style={{width: "5%", borderTop: thickBorderStyle, borderBottom: thickBorderStyle}}></col>
                                    <col span={1} style={{width: "5%", borderTop: thickBorderStyle, borderBottom: thickBorderStyle}}></col>
                                    <col span={1} style={{width: "5%", borderTop: thickBorderStyle, borderBottom: thickBorderStyle, borderRight: thickBorderStyle}}></col>

                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Αρ.</th>
                                    <th>Κωδικός Συστήματος / Χειροκίνητος Κωδικός</th>
                                    <th>Όνομα</th>
                                    <th>Εγκατάσταση</th>
                                    <th>Ποσότητα</th>
                                    <th>Συσχετιζόμενοι Λογιστικοί Λογαριασμοί</th>
                                    <th>Ημ/νία Κτήσης</th>
                                    {requestData.include_buys && (
                                        <th>Εγγραφή Αγοράς</th>
                                    )}
                                    <th>Αξία κτήσης</th>
                                    <th>Αξία πώλησης</th>
                                    <th>Προσθήκες</th>
                                    <th>Βελτιώσεις</th>
                                    <th>Απογραφή</th>
                                    <th>Κίνηση</th>
                                    <th>Συνολική Αποσβεσμένη αξία</th>
                                    <th>Αναπόσβεστη αξία / Υπόλοιπο</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((row, idx) => (
                                    <tr key={`rfab-${idx}`}>
                                        <td>{String(requestData.page - 1) * 20 + (idx + 1)}</td>
                                        <td>{row["mixedCode"]}</td>
                                        <td>{row["name"]}</td>
                                        <td>{installationOptions.find((el) => el.value === row["installation"])?.label || row["installation"]}</td>
                                        <td>{row["quantity"]}</td>
                                        <td>{row["accountingAccounts"]}</td>
                                        <td>{row["dateFrom"]}</td>
                                        {requestData.include_buys && (
                                            <td>
                                                <span style={{textDecoration: "underline", textDecorationStyle: "dotted", cursor: "pointer"}} onClick={() => openBuy(dispatch, TABS_DATA, company.id, row.correlatedBuy)}>
                                                    {row["correlatedBuyLabel"] || ""}
                                                </span>
                                            </td>
                                        )}
                                        <td>{getGreekCurrencyFormat(row["acquisitionCost"])}</td>
                                        <td>{row["saleAmount"] ? getGreekCurrencyFormat(row["saleAmount"]) : ""}</td>
                                        <td>{getGreekCurrencyFormat(row["totalAdditions"])}</td>
                                        <td>{getGreekCurrencyFormat(row["totalImprovements"])}</td>
                                        <td>{getGreekCurrencyFormat(row["totalCensus"])}</td>
                                        <td>{getGreekCurrencyFormat(row["totalUsage"])}</td>
                                        <td>{getGreekCurrencyFormat(row["accumulatedDepreciation"])}</td>
                                        <td>{row["isSold"] === true ? "ΕΠΩΛΗΘΗ" : getGreekCurrencyFormat(row["balance"])}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className={"mt-2"}>
                        <Col md={7}>
                            <BootstrapDropdown className="mb-3 mt-3">
                                <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic" disabled={loadingPrint}>
                                    Αποθήκευση αποτελεσμάτων {loadingPrint && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                </BootstrapDropdown.Toggle>
                                <BootstrapDropdown.Menu>
                                    <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                        Αποθήκευση ως PDF
                                    </BootstrapDropdown.Item>
                                    <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                        Αποθήκευση ως XLSX
                                    </BootstrapDropdown.Item>
                                </BootstrapDropdown.Menu>
                            </BootstrapDropdown>
                        </Col>
                        <Col md={5}>
                            <div className={"text-muted mb-1"}><i>Σύνολα</i></div>
                            <table className={"simpleClassicTable mb-3"}>
                                <tbody>
                                <tr>
                                    <td><strong>Συνολική Αξία Κτήσης</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.acquisitionCost)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Σύνολο Προσθήκεων/Βελτιώσεων</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.additionalImprovements)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Σύνολο Απογραφής</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalCensus)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Σύνολο Κίνησης</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalUsage)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Συνολικό αποσβεσμένο ποσό</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.accumulatedDepreciation)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Συνολικό αναπόσβεστο ποσό</strong></td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.balance)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export default ReportFixedAssetBook;
